import { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getFavsport } from "../components/actions/gameSettings";
import {
  loadRecentGamesFromStorage,
  partitionFavoritesRecents,
  removeRecentGame,
  saveRecentGamesToStorage,
} from "../utility/favoritesRecents";
import {
  fetchSportGroupIconMaps,
} from "../services/sportGroupIcons";

/**
 * Favorites / Recents sidebar data for Bet Builder (same UI as Straight Bet page).
 * On Open Bets, selecting a match navigates to Straight Bet for that game.
 */
export function useBetBuilderFavoritesRecents() {
  const history = useHistory();
  const [favGames, setFavGames] = useState([]);
  const [recentGames, setRecentGames] = useState(() =>
    loadRecentGamesFromStorage()
  );
  const [sportIconMaps, setSportIconMaps] = useState({
    groups: {},
    titles: {},
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const fetchedData = await getFavsport();
        if (cancelled) return;
        const favorites = Array.isArray(fetchedData?.result)
          ? fetchedData.result
          : [];
        setFavGames(favorites);
      } catch {
        /* ignore */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const maps = await fetchSportGroupIconMaps();
        if (!cancelled) setSportIconMaps(maps);
      } catch {
        /* ignore */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleClearAllRecents = useCallback(() => {
    setRecentGames([]);
    saveRecentGamesToStorage([]);
  }, []);

  const handleRemoveRecentGame = useCallback((game) => {
    if (!game?.id) return;
    setRecentGames((prev) => {
      const next = removeRecentGame(prev, game.id);
      saveRecentGamesToStorage(next);
      return next;
    });
  }, []);

  const handleFavRecentGameSelect = useCallback(
    (item) => {
      if (!item?.id) return;
      history.push(`/straight-bet/${item.id}`);
    },
    [history]
  );

  const { favorites: sidebarFavorites, recents: sidebarRecents } = useMemo(
    () => partitionFavoritesRecents(favGames, recentGames),
    [favGames, recentGames]
  );

  return {
    sidebarFavorites,
    sidebarRecents,
    sportIconMaps,
    handleFavRecentGameSelect,
    handleClearAllRecents,
    handleRemoveRecentGame,
  };
}
